export { default as I18N_MAIN } from './i18n';
export { default as mainRouter } from './main.router';

export const AppScene = () =>
  import(/* webpackChunkName: "main" */ './scenes/app/app.scene.vue');
